import { ModelRecord } from '@common/models/Model';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitClient extends ISyncModel {
  clientId: number;
  firstName: string;
  lastName: string;
  cellPhone: string;
  isOKToSMS: boolean;
  canSMS: boolean;
  canCall: boolean;
}

export class VisitClientModel
  extends SyncModel
  implements ModelRecord<IVisitClient>
{
  clientId: number;
  firstName: string;
  lastName: string;
  cellPhone: string;
  isOKToSMS: boolean;
  canSMS: boolean;
  canCall: boolean;
  constructor(params: Partial<IVisitClient>) {
    super(params);
    this.clientId = _.defaultTo(params.clientId, 0);
    this.firstName = _.defaultTo(params.firstName, '');
    this.lastName = _.defaultTo(params.lastName, '');
    this.cellPhone = _.defaultTo(params.cellPhone, '');
    this.isOKToSMS = _.defaultTo(params.isOKToSMS, false);
    this.canSMS = _.defaultTo(params.canSMS, false);
    this.canCall = _.defaultTo(params.canCall, false);
  }
}
